import React from 'react';
import { Button, CardContainer, Input } from '../../../components'
import Table from '../../../components/organisms/table'
import columns from './column'
import { IconImport } from '../../../assets/icons';
import { Link } from 'react-router-dom';
import { ADDREGIONAL } from '../../../routes/routesNames';
import { UseTable } from '../../../hooks';
import { UseGet } from '../../../hooks/api';

const RegionalCategory = () => {    
    const {
        filter,
        isLoading,
        data,
        error,
        totalPages,
        handlePagination,
        handleLimit,
        handleFilter,
    } = UseGet('/v1/domain?type=regional')

    const {
        isLoading : isLoadingPost ,
        dataRemove,
        handleSelected,
        handleRemove
    } = UseTable();
  return (
      <CardContainer >
            <div className="d-flex flex-row justify-content-between">
                <Input type="search" id="search" placeholder="Cari Regional" onChange={handleFilter} />
                {
                    dataRemove.length === 0  ? 
                    <div className="d-flex flex-row">
                        {/* <Button icon={IconImport} title="Import" className="btn btn-primary-light me-3 px-4" isSmall />                 */}
                        <Link to={ADDREGIONAL}>
                            <Button title="Tambah Regional" className="btn btn-primary" isSmall />                
                        </Link>
                    </div>
                    : 
                    <Button 
                        isLoading={isLoadingPost} 
                        onClick={() =>  handleRemove('/v1/domain/delete')}  
                        title="Hapus Regional" 
                        className="btn btn-danger" 
                        isSmall />                
                }
            </div>
                <Table 
                    filter={filter}
                    isLoading={isLoading}
                    error={error}
                    data={data}
                    totalPages={totalPages}
                    handlePagination={handlePagination}
                    handleLimit={handleLimit}
                    handleChangeSelect={handleSelected} 
                    columns={columns} 
                    isUpdate={filter.isUpdate} />
      </CardContainer>
  )
}

export default RegionalCategory